






import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component<DefaultLayout>({})
export default class DefaultLayout extends Vue {}
